import { type ReactNode } from 'react';

import styles from './AccordionContent.module.scss';

interface AccordionContentProps {
    readonly content?: ReactNode;
}

const AccordionContent = ({ content }: AccordionContentProps): JSX.Element => (
    <div className={styles.content}>{content}</div>
);

export { AccordionContent };
